import { ModelTryOrder } from 'services/multi-model-fallback';

/**
 * The order the meal scanner tries its configured models in (#6810).
 *
 * The other scanners shuffle, so each model gets a share of the traffic. The meal scanner keeps the
 * order `config/ScanProvider` lists, so the first model there answers every scan it can and the rest
 * are only backups. The reason is the grams: on the meal-scan quality test gpt-4.1-mini estimated
 * about 60% of the weighed food and gemini-2.5-flash 82-96%, and with the shuffle gpt-4.1-mini
 * answered about half of all prod meal scans. Measurements: design-docs/meal-photo-scanner.md,
 * "Model Selection".
 */
export const MEAL_SCAN_MODEL_TRY_ORDER = ModelTryOrder.AsConfigured;
